import { render, staticRenderFns } from "./ModalSetting.vue?vue&type=template&id=0b9c400b&scoped=true&"
import script from "./ModalSetting.vue?vue&type=script&lang=js&"
export * from "./ModalSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9c400b",
  null
  
)

export default component.exports